var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCourses = function SvgCourses(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#E4506B",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m16.385 13.048-4.83 4.29c-.807.717-2.08.145-2.08-.934V7.823c0-1.078 1.273-1.65 2.08-.935l4.83 4.291a1.25 1.25 0 0 1 0 1.87Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4897C5",
    d: "M10.046 22.867c-4.213-.795-7.671-3.976-8.745-8.189-.993-4.055.438-8.427 3.618-11.13s7.83-3.34 11.607-1.59 6.32 5.485 6.48 9.66c.158 4.888-3.022 9.38-7.673 10.89-.596.2-.357 1.154.278.955 4.453-1.431 7.712-5.367 8.308-10.017.557-4.572-1.63-9.143-5.525-11.607-3.856-2.425-8.904-2.465-12.76-.04C1.818 4.224-.408 8.715.07 13.207c.477 4.651 3.617 8.666 8.07 10.176.556.2 1.073.318 1.669.438.596.119.874-.835.238-.954"
  })));
};
export default SvgCourses;